export default {
  color: 'kleur',
  acidity: 'zuur',
  sweetness: 'suiker',
  intensity: 'intensiteit',
  complexity: 'verfijning',
  tannin: 'tannines'
}
